import { IRestaurant } from 'features/home/types/homeTypes';
import React from 'react';
import { TextRed } from './AddInformation';

interface IProps {
  restaurant: IRestaurant;
}

const SpecialTerm = ({ restaurant }: IProps) => {
  return (
    <TextRed style={{ marginBottom: '20px' }}>{restaurant?.onlineSettings?.specialTerms}</TextRed>
  );
};

export default SpecialTerm;
